import { Component, OnInit, Inject, DOCUMENT } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language/language.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { PoliciesRoutePaths } from '../policies-route-paths';
import { PolicyHttpService } from '../services/policy-http.service';
import { WindowService } from '../../../services/window/window.service';
import { BaseNoticeComponent } from '../common/base-notice';
import DOMPurify from 'dompurify';

@Component({
  selector: 'mpp-cookie-notice',
  templateUrl: './cookie-notice.component.html',
  styleUrls: ['./cookie-notice.component.scss'],
  standalone: false,
})
export class CookieNoticeComponent extends BaseNoticeComponent implements OnInit {
  sanitizedHtml: any;
  data: SafeHtml;

  constructor(
    @Inject(DOCUMENT) protected document: Document,
    protected window: WindowService,
    private service: PolicyHttpService,
    private sanitizer: DomSanitizer,
    private languageService: LanguageService,
    private spinnerService: SpinnerService,
  ) {
    super(document, window);
  }
  ngOnInit(): void {
    this.languageService.selectedLanguageId$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.loadCookieNotice();
    });
  }

  loadCookieNotice(): void {
    const spinner = this.spinnerService.show();
    this.service.getCookieNoticeHtml().subscribe((result) => {
      // We need this to prepend angular route to existing anchor links
      const replacedResult = result.replace(
        /href="#/gim,
        `href="${PoliciesRoutePaths.root}/${PoliciesRoutePaths.cookieNotice}#`,
      );
      // use DOMPurify to sanitize the HTML
      this.sanitizedHtml = this.getSafeContent(replacedResult);
      // skip Angular's default sanitizer since it is too strict and not configurable
      this.data = this.sanitizer.bypassSecurityTrustHtml(this.sanitizedHtml);
      spinner.hide();
    });
  }

  getSafeContent(content: string): string {
    return DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
  }
}
